import React from 'react';
import PropTypes from 'prop-types';

const Loader = (props) => {
	const {wrapperClassName, iClassName} = props;

	return (
		<div className={wrapperClassName}>
			<i className={iClassName}/>
		</div>
	);
};

Loader.defaultProps = {
	wrapperClassName: 'overlay',
	iClassName: 'fa fa-refresh fa-spin'
};

Loader.propTypes = {
	wrapperClassName: PropTypes.string,
	iClassName: PropTypes.string
};

export default Loader;